import React, {useEffect, useRef, useState} from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import {CircularProgress} from '@mui/material';
import {recaptchaApi} from '@api/recaptcha';

const Captcha_modal = ({
  open,
  onClose,
  onAccept,
  header,
  description,
}: {
  open: boolean;
  onClose: () => void;
  onAccept: () => void;
  header?: string;
  description?: string;
}) => {
  const recaptchaRef = useRef<any>(null);
  const [isCaptchaOk, setIsCaptchaOk] = useState<boolean>(false);

  const onChange = async (value: string) => {
    console.log(recaptchaRef);
    const isOk = await recaptchaApi(value);
    setTimeout(() => {
      setIsCaptchaOk(isOk);
    }, 2000);
  };

  useEffect(() => {
    if (isCaptchaOk && open) {
      onAccept();
    }
  }, [open, isCaptchaOk]);

  useEffect(() => {
    if (!open && recaptchaRef && isCaptchaOk) {
      recaptchaRef.current?.reset();
      setIsCaptchaOk(false);
    }
  }, [open, recaptchaRef]);

  const headerText = header ? header : 'Almost Done!';
  const descriptionText = description ? description : 'Please verify you are not a robot';

  return (
    <div>
      <div className={open ? 'block modal fade show ' : 'fade modal hidden'}>
        <div className="modal-dialog max-w-[500px] w-full ">
          <div className="modal-content p-8 dark:!bg-dark-navy bg-none relative">
            <div className="flex items-start jusitfy-between w-full mb-10">
              <h1 className="text-xl font-semibold">{isCaptchaOk ? 'Please Wait' : headerText}</h1>
              {!isCaptchaOk && (
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => {
                    setIsCaptchaOk(false);
                    onClose();
                  }}
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M17.912 5.02948L11.999 10.9425L6.08604 5.02948C5.94382 4.89934 5.75688 4.82909 5.56415 4.83336C5.37142 4.83763 5.18777 4.91609 5.05146 5.0524C4.91515 5.18872 4.83669 5.37236 4.83242 5.56509C4.82814 5.75782 4.8984 5.94476 5.02854 6.08698L10.9385 12L5.02704 17.9115C4.95482 17.9803 4.89708 18.0629 4.85723 18.1543C4.81738 18.2458 4.79621 18.3443 4.79498 18.4441C4.79374 18.5438 4.81246 18.6428 4.85004 18.7352C4.88761 18.8277 4.94328 18.9116 5.01378 18.9822C5.08427 19.0528 5.16817 19.1086 5.26053 19.1463C5.3529 19.184 5.45187 19.2029 5.55163 19.2018C5.65139 19.2007 5.74992 19.1797 5.84144 19.1399C5.93296 19.1002 6.01561 19.0426 6.08454 18.9705L11.999 13.059L17.912 18.972C18.0543 19.1021 18.2412 19.1724 18.4339 19.1681C18.6267 19.1638 18.8103 19.0854 18.9466 18.9491C19.0829 18.8127 19.1614 18.6291 19.1657 18.4364C19.1699 18.2436 19.0997 18.0567 18.9695 17.9145L13.0565 12.0015L18.9695 6.08698C19.0418 6.01815 19.0995 5.93558 19.1393 5.84412C19.1792 5.75266 19.2004 5.65416 19.2016 5.5544C19.2028 5.45464 19.1841 5.35564 19.1465 5.26323C19.109 5.17081 19.0533 5.08683 18.9828 5.01624C18.9123 4.94564 18.8284 4.88985 18.736 4.85215C18.6437 4.81444 18.5447 4.79558 18.4449 4.79668C18.3452 4.79777 18.2467 4.8188 18.1551 4.85852C18.0636 4.89824 17.981 4.95586 17.912 5.02798V5.02948Z"
                      fill="#9AA09D"
                    />
                  </svg>
                </button>
              )}
            </div>
            <div className={`w-full text-center min-h-[100px] ${!isCaptchaOk && 'hidden'}`}>
              <CircularProgress className="!text-green-2" />
            </div>
            <div className={`${isCaptchaOk && 'hidden'}`}>
              <div className="dark:text-grey text-dark-grey mb-6">{descriptionText}</div>
              <div className="captcha-container w-full flex justify-center">
                <ReCAPTCHA
                  id="tes"
                  ref={recaptchaRef}
                  sitekey={process.env.NEXT_PUBLIC_CAPTCHA_SITE_KEY}
                  onChange={async (value: string) => await onChange(value)}
                  onExpired={() => {
                    recaptchaRef.current?.reset();
                  }}
                />
                {/* <Reaptcha
                  id="tes"
                  ref={recaptchaRef}
                  sitekey={process.env.NEXT_PUBLIC_CAPTCHA_SITE_KEY}
                  onVerify={async (value: string) => await onChange(value)}
                  onRender={() => recaptchaRef.current?.reset()}
                /> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Captcha_modal;
